<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import { IconType } from '$shared/constants/IconType';
  import { EmptyLabelDefault } from '$provider/constants/global';

  interface Props {
    value: string;
    showIcon?: boolean;
    active?: boolean;
    onclick?: () => void;
  }

  let { value, showIcon = true, active = false, onclick }: Props = $props();

  const sensitiveTextCount = 7;

  let unMask = $state(false);

  let iconValue = $derived(!unMask ? 'icon-eye' : 'icon-eye-off');

  $effect(() => {
    unMask = active;
  });

  const onClickAction = async (): Promise<void> => {
    unMask = !unMask;
    onclick?.();
  };
</script>

<div data-cy="simple-sensitive-content" class="comp-simple-sensitive-text">
  {#if value}
    {#if unMask}
      <div data-cy="sensitive-value" class="value">{value}</div>
    {:else}
      <div data-cy="sensitive-dot-value" class="value-hidden">
        {#each Array(sensitiveTextCount) as _}
          <div class="sensitive-dot">{''}</div>
        {/each}
      </div>
    {/if}
    {#if showIcon}
      <div class="action">
        <Icon
          name="sensitive-eye"
          value={iconValue}
          type={IconType.Button}
          onclick={onClickAction}
        />
      </div>
    {/if}
  {:else}
    {EmptyLabelDefault}
  {/if}
</div>

<style>
  .comp-simple-sensitive-text {
    display: flex;
    align-items: center;
  }
  .comp-simple-sensitive-text .value {
    white-space: nowrap;
  }
  .comp-simple-sensitive-text .action {
    margin-left: 4px;
  }
  .value-hidden {
    display: flex;
  }
  .sensitive-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: var(--grey-dark);
  }
  .sensitive-dot:not(:last-child) {
    margin-right: 4px;
  }
</style>
